var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.free)?_c('h-table-free',{attrs:{"table":_vm.table},on:{"create":function($event){return _vm.$emit('create', $event)},"more":function($event){return _vm.$emit('more', {
    free: true,
    id: _vm.table.id,
    event: $event,
  })}}}):_c('h-table-occupied',{attrs:{"table":_vm.table,"order":_vm.order},on:{"preview":function($event){return _vm.$emit('preview', $event)},"edit":function($event){return _vm.$emit('edit', $event)},"more":function($event){return _vm.$emit('more', {
    free: false,
    id: _vm.order.id,
    event: $event,
  })}}})
}
var staticRenderFns = []

export { render, staticRenderFns }